<template>
    <div>
        <div :class="'d-flex justify-content-center' + (!textValue?' align-items-center' : '')"
             style="background: white;max-height: max-content;">

            <b-button v-show="this.showCloseButton" @click="onClose" class="close position-fixed" aria-label="Close">
                <span class="d-inline-block" aria-hidden="true">&times;</span>
            </b-button>
            <b-overlay :show="this.loadingAgreement" rounded="sm"
                       :style="{ width: textValue ? '50%' : '20%' }">
                <div v-if="textValue" class="mt-3">
                    <rich-text :value="textValue" :disabled=true>
                    </rich-text>
                </div>
                <div v-else class="position-relative" style="width: 50%;">
                    <EmptyData></EmptyData>
                </div>
            </b-overlay>
        </div>
    </div>
</template>

<script>
import RichText from "@/components/em/editor/richText";
import EmptyData from "@/components/em/common/EmptyData";
import emCommonApiMixin from "@/mixin/em/common/api";

export default {
    name: "agreementContent",
    components: {EmptyData, RichText},
    mixins: [emCommonApiMixin],
    props: {
        agreementContent: String,
        showCloseButton: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            textValue: '',
            loadingAgreement: false,
        }
    },
    methods: {
        onClose() {
            this.$emit('close')
        }
    },
    created() {
        this.textValue = this.agreementContent
        const agreementId = this.$route.query.id
        if (!this.textValue && agreementId) {
            this.loadingAgreement = true
            let url = `${this.$_emApiMixin_entityBaseApi("sithMesAgreement")}/findById?id=`+agreementId;
            this.$_emApiMixin_get(url)
                .then(response => {
                    if (response) {
                        this.textValue = response.content
                    }
                }).finally(() => this.loadingAgreement = false)
        }
    }
}
</script>

<style scoped>

::v-deep .quillWrapper .ql-snow.ql-toolbar {
    display: none;
}

::v-deep .ql-container.ql-snow {
    border: none;
}

.row {
    margin: 0 auto 50px;
    max-width: 820px;
}

.close {
    font-size: 28px;
    right: 36px;
    top: 36px;
}
</style>
